<template>
  <v-flex class="media-container" :class="isFullScreen?'fullscreen':''" > 
   <v-card class="media-popout-card" @mouseenter="onMouseEnter" @mouseleave="onMouseLeave" v-bind:class="{'pop-out' : isFreeMode, 'hide-pop-out':!isVideoVisible|| ( !isExpanded && ($isMobile || !isCurrentDefaultLanguage)) }">
    <v-layout class="media-display-container" row justify-space-between v-show="!isFullScreen">
      <!-- <DialogHeader :icon="'mdi-minus'" :closeable="true" @close="onDialogHeaderClose" class="moveable"></DialogHeader> -->
      <v-flex class="media-frame">
                    <vue-draggable-resizable 
    class-name="noselect" 
v-bind:class="{'is-video-resizable-disabled' : isExpanded || $isMobile,'is-video-resizable-disabled-mobile': !isVideo && isExpanded, 'popout-draggable':isFreeMode}"
    :w="captionWidth" 
    :collision="false" 
     :draggable="false"
    axis="both"
    :handles="['ml','mr']" 
    :active="isFreeMode" 
    :lock-aspect-ratio="true"
    :onResize="onResizeCallback"
    :prevent-deactivation="true" >
        <div v-show="!isVideo" class="audio-placeholder"></div>
          <Media
            v-show="isVideo"
            class="media-player"
            data-tutorial="media_player"
            :kind="'video'"
            :isMuted="(false)"
            :src="mediaControl.url"
            :poster="mediaControl.thumbnailUri || ''"
            :autoplay="false"
            :controls="false"
            :loop="false"
            preload="metadata"
            @error="onMediaError"
            @pause="mediaPaused"
            @play="mediaPlay"
            @ended="mediaEnded"
            @seeked="onSeeked"
            @timeupdate="onTimeUpdated"
            @loadedmetadata="onLoaded"
            @click="onScreenClicked"
            @webkitendfullscreen="onMobileFullScreenEnd"
            :ref="'video_player'"
            :style="{height: !isFreeMode ? '200px':'auto',width: !isFreeMode ? '334px': '100%'}"
            playsinline
            autobuffer
          ></Media>
           </vue-draggable-resizable>
        <v-layout
          v-show="isCaption"
          class="float-caption-container"
          align-center
          justify-center
          :style="captionContainerPosition"
          row
        >
          <div class="float-caption" v-show="floatCaptionActive" :style="`font-size:${(captionWidth/334*15) || 15}px`" v-html="activeText">{{activeText}}</div>
          <div class="float-caption-placeholder" v-show="!floatCaptionActive"></div>
        </v-layout>
      </v-flex>

    </v-layout>
      <v-layout
        class="media-control-container"
        v-bind:class="{'control-visible':controlVisible || isFullScreen || $isMobile}"
        row
        justify-space-between
       
      >
        <v-flex class="media-control">
          
          <!-- Play control-->
          <play-pause-button @change="onMediaToggle" :isMediaPaused="!$refs.video_player || $refs.video_player && $refs.video_player.paused"></play-pause-button>

          <!-- Volume control-->
          <volume-button @change="onVolumeChange" :defaultVolume="volume"></volume-button>

          <!-- Play back speed control-->
          <play-back-speed-button @change="onSpeedChange" :defaultSpeed="speed"></play-back-speed-button>

          <!-- Caption control-->
          <caption-button @change="onCaptionPosition" @toggle="onCaptionToggle" :defaultPosition="captionPosition" :defaultIsCaption="isCaption"> </caption-button>

          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn
                class="media-control-button video-fullscreen"
                v-on="on"
                @click="onFullScreen"
              >
                 <v-icon>{{localIcons['mdi-fullscreen']}}</v-icon>
              </v-btn>
            </template>
            <span>{{ $lang.share.full_screen }}</span>
          </v-tooltip>
        </v-flex>
      </v-layout>
    </v-card>

  <slot name="saving-slot"></slot>
    <v-layout
      class="media-slider-container"
      :class="isFullScreen?'fullscreen':''"
      row
      justify-space-between
    >
      <div v-if="isMediaLoaded" class="media-time-start">{{currentMediaTime}}</div>
      <div v-if="!isMediaLoaded" class="media-time-start loading">--:--:--</div>
      <v-flex>
        <v-slider
          v-model="sliderValue"
          ref="mediaslider"
          class="media-slider custom-slider"
          :max="mediaControl.duration"
          :min="0"
          :step="0.02"
          color="#20f7c4"
          height="10px"
          hide-details
          @click="onMediaClicked"
          @input="onMediaSliderChange"
          @start="onMediaSliderStart"
          @end="onMediaSliderEnd"
        ></v-slider>
      </v-flex>
      <div v-if="isMediaLoaded" class="media-time-end">{{totaltMediaTime}}</div>
      <div v-if="!isMediaLoaded" class="media-time-end loading">--:--:--</div>
    </v-layout>
  </v-flex>
</template>

<script>
import { mdiFullscreen} from '@mdi/js'

const moment = require("moment");
import Media from "@dongido/vue-viaudio";
// import storeHelper from "@/utils/storeHelper";
import PlayPauseButton from "./PlayPauseButton.vue";
import PlayBackSpeedButton from "./PlayBackSpeedButton.vue";
import CaptionButton from "./CaptionButton.vue";
import VolumeButton from "./VolumeButton.vue";
// import Note from "../editing/Note";
import transcriptHelper from "@/utils/transcriptHelper";
// import storyboardHelper from "@/utils/storyboardHelper";
// import editingHelper from "@/utils/editingHelper";
import textHelper from "@/utils/textManager";
import { debounce } from "debounce";
// import {scroller} from 'vue-scrollto/src/scrollTo';
import VueDraggableResizable from 'vue-draggable-resizable';

//const storeModules = storeHelper.createHelpers(["editSession", "transcript"]);

export default {
  props: ["isWaveFormReady","isCurrentDefaultLanguage","popoutVideoVisible","mediaControlInfo", "isFullScreen", "isExpanded", "isTranscriptLoaded", "isTranscriptCaption", "indexes", "language",'scrollIndex', 'readOnly', 'isPendingToSave', 'readOnlyPhrases','videoCuts'],
  components: {
    Media,
    PlayPauseButton,
    PlayBackSpeedButton,
    VolumeButton,
    //Note,
    VueDraggableResizable,
    CaptionButton
  },
  data() {
    return {
      isCaption: false,
      isMediaLoaded: false,
      controlVisible: false,
      isMouseOnVideo: false,
      clickedNode: null,
      debounceControl: null,
      debounceSkipMedia:null,
      wordHighlightingAnimation: null,
      speed: 1,
      volume: 0.5,
      sliderValue: 0,
      floatCaptionActive: false,
      activeText: "",
      currentPhaseIndex: 0,
      readOnlyPhaseIndex: 0,
      isDragging: false,
      isScrolling: false,
      isTimelineScrolling:false,
      scrollTime: 200,
      track:null,
      pauseTime:null,
      phraseScroller:null,
      timelineScroller:null,
      selectorById: null,
      noScroll: false,
      noAutoPaginate: false,
      isSkipping: false,
      videoCutIndex: 0,
      captionWidth:334,
      captionPosition:0.2,
      mediaControl:{},
      isVideo: false,
      localIcons:{
          'mdi-fullscreen':mdiFullscreen
        }
    };
  },
  name: "media-player",
  methods: {
    onMediaError(e){
      /* eslint-disable vue/no-mutating-props */
      console.log(e.currentTarget.error.message);
      if(this.mediaControl.type === 'video'){
        this.mediaControl.url = this.mediaControl.altUrl || this.mediaControl.url ;
      }
      /* eslint-enable vue/no-mutating-props */
    },
    onResizeCallback(){
        const me = this;
        const videoEl = document.querySelector('video.media-player');

        if(videoEl){
          me.captionWidth = parseInt(window.getComputedStyle(videoEl).width,10);
        }
        return true;
    },
    onDialogHeaderClose(){
      const me = this;
      me.$emit('close-popout');

    },
    onScreenClicked() {
      const me = this;
      if(me.$refs.video_player){
        !me.$refs.video_player.paused ? me.onPaused() : me.onPlay();
      }
    },
    onFullScreen(){
      const me = this;
      if(me.$isMobile){
        me.onPaused();
        me.$refs.video_player.removeAttribute('playsinline');
        
        me.$nextTick(() => {
          me.onPlay();
        });
      }
      else{
      if (me.$refs.video_player.requestFullscreen) {
        me.$refs.video_player.requestFullscreen();
      } else if (me.$refs.video_player.mozRequestFullScreen) {
        me.$refs.video_player.mozRequestFullScreen();
      } else if (me.$refs.video_player.webkitRequestFullscreen) {
        me.$refs.video_player.webkitRequestFullscreen();
      } else if (me.$refs.video_player.msRequestFullscreen) { 
        me.$refs.video_player.msRequestFullscreen();
      }
      }

      
      me.createTextTrack();
    },
    onMobileFullScreenEnd(){
      const me = this;
      if(me.$isMobile){
        me.$refs.video_player.setAttribute('playsinline',true);
      }
    },
    onMouseEnter(){
      const me = this;
       if (me.debounceControl) {
        me.debounceControl.clear();
      }
      me.controlVisible = true;
    },
    onMouseLeave(){
      const me = this;
      me.debounceControl();
    },
    onMouseMove() {
      const me = this;
      if (me.debounceControl) {
        me.debounceControl.clear();
      }

      me.controlVisible = true;
      me.debounceControl();
    },
    mediaPaused() {
      const me = this;
      setTimeout(function() {
        me.setVideoInfo({ playing: false });
      }, 300);

      setTimeout(function() {
        // cancel requestAnimationFrame after 2 seconds
        me.stopWordHighlightAnimation();
      }, 2000);
    },
    stopWordHighlightAnimation(){
      const me = this;
      // cancel requestAnimationFrame after 2 seconds
      if(me.wordHighlightingAnimation){
        cancelAnimationFrame(me.wordHighlightingAnimation);
      }
    },
    mediaPlay() {
      const me = this;
      me.scrollTime = 200;
      me.setVideoInfo({ playing: true });
      requestAnimationFrame(function() {
        me.loopHighlightWord(false);
      });
    },

    loopHighlightWord(isDrag) {
      const me = this;

      if(!me.$refs.video_player){
        return;
      }

      const timestamp = isDrag ? me.$refs.mediaslider.value : me.$refs.video_player.currentTime;
      const range = me.videoCuts.length && me.videoCuts[me.videoCutIndex]

      if(range && me.$refs.video_player.currentTime >= (range[0] - 0.016) && me.$refs.video_player.currentTime < range[1]){
       
        me.debounceSkipMedia(range[1]);
      }

      // // prevent set scroll after paused
      // if(me.$refs.video_player && !me.$refs.video_player.paused){
      //   me.scrollToTimeline(me.$refs.video_player.currentTime)
      // }
     // storyboardHelper.scrollToTimeline(me.$refs.video_player.currentTime, me.$refs.video_player.duration);
      
      let phraseIndex = me.updateActivePhraseIndex(timestamp);

      // Find the word index
      if (phraseIndex > -1) {

     //   me.currentPhaseIndex = phraseIndex;
           
        transcriptHelper.highlightWordByTime(
          timestamp,
          me.phrases,
          isDrag,
          me.readOnly
        );

        // Set float
        me.activeText = me.phrases[phraseIndex].transcript;
        me.activeText = textHelper.getPhraseText(me.phrases[phraseIndex], true);

        const regex = /(?:\r\n|\r|\n)/g;

        me.activeText = me.activeText.replace(regex, '<br>');
        me.floatCaptionActive = me.activeText !== null;
      }
      else{
        me.activeText = '';
      }

      me.wordHighlightingAnimation = requestAnimationFrame(function() {
        me.loopHighlightWord(isDrag);
      });
    },
    onCaptionToggle() {
      this.isCaption = !this.isCaption;
    },
    onCaptionPosition(captionPosition){
      const me = this;
      me.captionPosition = captionPosition;
      me.setVideoInfo({ captionPosition });
    },
    onLoaded() {
      const me = this;
      const speed = me.speed;
      const volume = me.volume;
      let duration = me.mediaControlInfo && me.mediaControlInfo.duration || 0;
      
      me.isCaption = me.isTranscriptCaption === 1;
      if (me.$refs.video_player) {
        me.$refs.video_player.playbackRate = speed;
        me.$refs.video_player.volume = volume;
        duration = me.$refs.video_player.duration;
        me.isMediaLoaded = true;
      }

      if(me.$isMobile){
        me.captionPosition= 0;
      }
      // me.createTextTrack();
      // me.track = me.$refs.video_player.addTextTrack("captions", me.$lang.language[me.language], me.language);
      // me.track.mode = "showing";


      // me.phrases.forEach(phrase => {
      //   let tempCue = new VTTCue(phrase.startTime, phrase.endTime, phrase.transcript)
      //   tempCue.line = -2;
      //   me.track.addCue(tempCue);
      // });
      me.$nextTick(function(){
        me.setVideoCutOnSlider();
        me.$emit('validate-phrases');
      });
      me.setVideoInfo({ speed, volume, duration });
    },
    setVideoCutOnSlider(videoCuts){
      const me = this;

      if(!me.$refs.video_player){
        return;
      }

      const duration = me.$refs.video_player.duration;
      videoCuts = videoCuts || me.videoCuts;

      if(!duration || !videoCuts){
        return;
      }

      const allChunks = document.querySelectorAll('.media-video-cut');
      allChunks.forEach((c)=>{
        var startTime = Number(c.id.replace('-','.'));
        var exist = videoCuts.find(function(cut){return cut[0] === startTime});

        if(!exist){
          c.remove();
        }

      })

      videoCuts.forEach((range)=>{
          const start = range[0]+'';
          const id = start.replace('.','-');
          let segment = document.querySelector(`[id='${id}'].media-video-cut`);
          if(!segment){
            const div = document.createElement('div');
            const width = (range[1]-range[0]) / duration * 100;
            const left = range[0] / duration * 100;
            div.classList.add('media-video-cut');
            div.id= id;
            div.style = `left:${left}%; width:${width}%`;
            document.querySelector('.media-slider .v-slider__track-container').append(div);
          }
      })
    },
    getDurationFormat(seconds) {
      const me = this;
      const duration = me.$refs.video_player.duration;
      let splitList = [];

      splitList = transcriptHelper.getTimeFormat(duration, seconds, "second").split(".");

      return `${splitList[0]}<span class="milliseconds">.${splitList[1]}</span>`;
    },
    onSettingClicked() {
      const me = this;
      me.$emit("open-setting");
    },
    onSpeedChange(newVal) {
      const me = this;
      if (newVal) {
        me.$refs.video_player.playbackRate = newVal;
        me.setVideoInfo({ speed: newVal });
      }
    },
    onVolumeChange(newVal) {
      const me = this;
      if (newVal) {
        me.$refs.video_player.volume = newVal;
        me.setVideoInfo({ volume: newVal });
      }
    },
    onMediaSliderStart(){
      const me = this;
      me.isDragging = true;
      me.scrollTime = 100;
      requestAnimationFrame(function() {
        me.loopHighlightWord(true);
      });
    },
    onMediaSliderEnd(){
      const me = this;
      me.isDragging = false;
      me.stopWordHighlightAnimation();
    },
    onMediaClicked(){
      const me = this;
      if(!me.isDragging){
        me.setMediaTime(me.$refs.mediaslider.value);
        me.scrollTime = 20;
        let phraseIndex = transcriptHelper.getPhraseIndexByTime(
          me.phrases,
          me.$refs.mediaslider.value
        );

        phraseIndex = phraseIndex < 0 ? phraseIndex * -1 : phraseIndex;

        if(me.phrases[phraseIndex]){
          transcriptHelper.scrollToTarget(document.querySelector('#'+me.phrases[phraseIndex].id));
        }
      }
    },
    getVideoCutIndex(time){
      const me = this;
      var count = 0;
      const currentTime = time || me.$refs.video_player.currentTime;

      for(var i = 0 ; i < me.videoCuts.length; i++){
        if(me.videoCuts[i][0] > currentTime || (me.videoCuts[i][0] <= currentTime &&  me.videoCuts[i][1] >= currentTime)){
          break;
        }
        count++;
      }

      return count;
    },
    onMediaSliderChange(val) {
      const me = this;

      // Update the actual time of the video
      if(me.isDragging){
        me.$refs.video_player.currentTime = val;
      }


      me.clickedNode = null;
    },
    onTimeUpdated(e) {
      const me = this;
     // const currentTime = Math.floor(e.target.currentTime * 100) / 100;
      const currentTime = transcriptHelper.getRoundTo2Decimal(e.target.currentTime)
      // Update the current media time
      me.setVideoInfo({ time: currentTime });

      // Set the slider time, wont trigger onMediaSliderChange()
      me.sliderValue = currentTime;
      me.videoCutIndex = me.getVideoCutIndex(currentTime);

      if(me.pauseTime && me.pauseTime < (currentTime + 0.25)){
        me.pauseTime = null;
        me.onPaused();
      }
    },
    onSeeked(e) {
      const me = this;
      me.setVideoInfo({
        seekTime: e.target.currentTime,
        time: e.target.currentTime
      });
    },
    onMediaToggle(){
      const me = this;
      if(me.$refs.video_player.paused){
        me.onPlay()
      }
      else{
        me.onPaused()
      }
    },
    onPlay() {
      const me = this;

      if (
        Math.round(me.$refs.video_player.duration) ===
        Math.round(me.$refs.video_player.currentTime)
      ) {
        me.$refs.video_player.currentTime = 0;
      }
      
      me.videoCutIndex = me.getVideoCutIndex();
      me.$emit('on-screen-switch-toggle',false);
      me.$refs.video_player.play();
    },
    onPaused() {
      const me = this;
      
      me.$emit('on-screen-switch-toggle',true);
      me.$refs.video_player.pause();

      // if(!skipCaretSync){
      //   me.setCaret();
      // }
    },
    mediaEnded(){
      const me = this;
      
      me.$emit('on-screen-switch-toggle',true);
    },
    setVideoInfo(data){
      const me = this;
           /* eslint-disable vue/no-mutating-props */
           me.mediaControl = Object.assign(me.mediaControl, data);
/* eslint-enable vue/no-mutating-props */
    },
    setCaret(){
      const me = this;
      const currentPhrase = me.phrases[me.currentPhaseIndex];
      let wordIndex = transcriptHelper.getWordIndexByTime(currentPhrase.words, me.$refs.video_player.currentTime);

      let charIndex = wordIndex >= 0 ? currentPhrase.words[wordIndex].end : 0;
      me.$nextTick(function(){
        me.$emit('set-caret', {phraseId:currentPhrase.id, charIndex: charIndex})
      })
    },
    updateActivePhraseIndex(currentTime){
      const me = this;
      let phraseIndex = transcriptHelper.getPhraseIndexByTime(
        me.phrases,
        currentTime
      );

      if(phraseIndex >=0){
        me.currentPhaseIndex = phraseIndex;
      }
      else{
          me.currentPhaseIndex = -phraseIndex;
        }


        me.noAutoPaginate = false;

      return phraseIndex;
    },
    setMediaTime(time, endTime, noScroll, noAutoPaginate, autoPlay) {
      const me = this;
     // const currentTime = Math.floor(time * 100) / 100;
      const currentTime =  transcriptHelper.getRoundTo2Decimal(time);

      //me.selectorById = null;
      me.noScroll = !!noScroll;
      me.noAutoPaginate = !!noAutoPaginate;

      if(endTime){
        me.pauseTime = endTime;
      }

      // This would trigger MediaSliderChange()
      me.setVideoInfo({ time: currentTime });
      me.$refs.video_player.currentTime = currentTime;
      me.sliderValue = currentTime;
      transcriptHelper.highlightWordByTime(currentTime, me.phrases, null, me.readOnly);

     me.updateActivePhraseIndex(currentTime);

      me.isSkipping = false;

      if(autoPlay){
        me.$nextTick(function(){
          me.onPlay();
        })
      }
      
    },
    createTextTrack(){
      const me = this;
      const video = me.$refs.video_player;

      if(video.textTracks.length > 0){
        // Find the desired TextTrack object by its label or language
        const trackToRemove = Array.from(video.textTracks).find((track) => track.label === (me.$lang.language[me.language] || me.language)); // Replace 'English' with the label of the track to remove

        // Remove the TextTrack
        if (trackToRemove) {
          video.textTracks.remove(trackToRemove);
        }
      }

      me.track = video.addTextTrack("captions", (me.$lang.language[me.language] || me.language), me.language);
      me.track.mode = "showing";
      me.phrases.forEach(phrase => {
        let tempCue = new VTTCue(phrase.startTime, phrase.endTime, phrase.transcript)
        tempCue.line = -2;
        me.track.addCue(tempCue);
      });
    },
    getTimeFormat(milliSeconds, unit, type){
      const me = this;
      if(type === 'standard'){
        return moment.duration(milliSeconds, unit).format('hh:mm:ss', { trim: false })
      }
      
      if (me.mediaControl.duration >= 3600) {
        return moment.duration(milliSeconds, unit).format('h:mm:ss.SS', { trim: false })
      } else if (me.mediaControl.duration >= 60) {
        return moment.duration(milliSeconds, unit).format('mm:ss.SS', { trim: false })
      } else {
        return moment.duration(milliSeconds, unit).format('m:ss.SS', { trim: false })
      }
    }
  },
  computed: {
    captionContainerPosition(){
      const me = this
      const videoEl = document.querySelector('video.media-player');
      
      if(!videoEl){
        return 'bottom:'+ (200 * me.captionPosition)+'px';
      }
      return 'bottom:'+ parseInt(window.getComputedStyle(videoEl).height,10)* this.captionPosition+'px';
    },
    isDisplayPlay(){
      return !(this.$refs.video_player && !this.$refs.video_player.paused)
    },
    /* eslint-disable vue/no-side-effects-in-computed-properties */
    isFreeMode(){

      const me = this;
      const newIsFreeMode = !me.isExpanded && !me.$isMobile && me.$route.name !=='share';
      if(!newIsFreeMode){
        me.captionWidth = 334;
      }
      else{
        me.captionWidth = 530;
      }
      return newIsFreeMode;
    },
    /* eslint-enable vue/no-side-effects-in-computed-properties */
    isVideoVisible(){
      return !this.isExpanded && this.popoutVideoVisible || this.isExpanded;
    },
    phrases(){
      return this.readOnlyPhrases;
    },
    currentMediaTime() {
      const me = this;
      return me.getTimeFormat(me.sliderValue, "second", "standard");
    },
    totaltMediaTime() {
      const me = this;
      return me.getTimeFormat(
        me.$refs.video_player.duration,
        "second",
        "standard"
      );
    }
  },
  mounted() {
    const me = this;

    me.mediaControl = Object.assign({},me.mediaControl, me.mediaControlInfo);
    me.debounceControl = debounce(function() {
      me.controlVisible = false;
    }, 2000);

    me.debounceSkipMedia = debounce(function(skipTo) {
       me.setMediaTime(skipTo);
       me.videoCutIndex++;
    }, 20, true);

    //add caption
    me.isCaption = me.isTranscriptCaption === 1;

    document.addEventListener('keydown', function (event) {
      const keyCode = event.which || event.keyCode || 0;

      if(!me.$refs.video_player) return false

      if (keyCode == 9) {
        event.preventDefault();
        me.onScreenClicked();
      }
      else if((event.ctrlKey || event.metaKey )&& (keyCode === 37 || keyCode === 39 || keyCode === 38|| keyCode === 40 )){
        
        event.preventDefault();
        if(keyCode === 37){
          me.setMediaTime( Math.max(0, me.$refs.video_player.currentTime - 3));
        }
        else if(keyCode === 39){
          me.setMediaTime( Math.min(me.$refs.video_player.duration, me.$refs.video_player.currentTime + 3));
        }
        else if(keyCode === 38){
          if(me.phrases[me.currentPhaseIndex-1]){
            me.setMediaTime( me.phrases[me.currentPhaseIndex-1].startTime+ 0.01);
          }
          
        }
        else if(keyCode === 40){
          if(me.phrases[me.currentPhaseIndex+1]){
            me.setMediaTime( me.phrases[me.currentPhaseIndex+1].startTime + 0.01);
          }
          
        }
        
      }
    });
    
    
  },
  beforeDestroy() {
    // Remove the highlighting
    transcriptHelper.clearHighlight();
  },
  watch: {

    mediaControlInfo: {
      handler (newVal) {
        const me = this;
        me.mediaControl = Object.assign({},me.mediaControl, newVal);
        me.isVideo = newVal.type; 
      },
      deep: true
    },
    videoCuts(newCuts){
      const me = this;

      me.setVideoCutOnSlider(newCuts);
    },
    currentPhaseIndex(newVal){
      const me = this;

      if(me.phrases[newVal]){
          transcriptHelper.scrollToTarget(document.querySelector('#'+me.phrases[newVal].id));
        }

      me.noScroll = false;
    }
  }
};
</script>

<style>

.row{
  margin:0px!important;
}

.popout-draggable{
    min-width: 334px!important;
    min-height: 200px!important;
    padding: 0px 10px;
        height: auto!important;
}


.popout-draggable .handle{
  border:none;
  background: none;
  /* border:1px solid gray; */
    height: 25px;
    border-radius: 2px;
    color: lightgray;

}

.popout-draggable .handle:hover{
  /* background: #00ffff; */
  border:none;
  /* background: #45D4BE; */
    opacity:1;
}


.popout-draggable .handle::before{
    margin-left:-1px;
    content: "\2261";
    color: gray;
  -webkit-transition: all 200ms ease-in;
  -moz-transition: all 200ms ease-in;
  -o-transition: all 200ms ease-in;
  transition: all 200ms ease-in;
  margin-top:-12.5px;
}

.popout-draggable .handle:hover::before{
    margin-left:-1px;
    color: lightgray;
}

.handle-br {
    bottom: -70px;
    right: -10px;
    cursor: se-resize;
}

.is-video-resizable-disabled{
      width: auto!important;
    height: auto!important;
}

.is-video-resizable-disabled-mobile{
      width: auto!important;
    height: 200px!important;
}

.is-video-resizable-disabled .handle-ml,
.is-video-resizable-disabled .handle-mr{
  display:none!important;
}

.media-video-cut{
  /* background: #fd899f; */
    background: #ff365b;
opacity: 0.6;
    height: 8px;
    position: absolute;
    top: -3px;
    border-radius: 2px;
    z-index: 10000;
}
.media-time-warning{
  background: orange;
    height: 8px;
    position: absolute;
    opacity: 1;
  z-index: 10;
  top:-3px;
    border-radius: 2px;
}
.media-time-inner{
  width:auto;
  min-width: 300px;
  background:whitesmoke;
  color:red;
  box-shadow: 0 1px 4px rgb(1 1 1 / 15%);
  z-index: 100;
}

/* .media-time-warning {
  position: relative;
  display: inline-block;
  border-bottom: 1px dotted black;
} */

.media-time-warning .media-time-inner {
  visibility: hidden;
  background-color: whitesmoke;
  color: gray;
  text-align: center;
  border-radius: 6px;
  padding: 0px 10px 10px 0px;
  position: absolute;
  z-index: 10;
  bottom: 125%;
  left: 50%;
  margin-left: -150px;
  opacity: 0;
  transition: opacity 0.3s;
  text-align: left;
  min-height:58px;
}

.media-time-warning .media-time-inner::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: #555 transparent transparent transparent;
}

.media-time-warning:hover .media-time-inner {
  visibility: visible;
  opacity: 1;
}

.tooltip-phrase-container i{
  position: absolute;
  left:70px;
  top:3px;
  color: #3bd5b1;
}

.tooltip-phrase-container{
  position:relative;
  padding: 0px 0px 0px 80px;
}

.tooltip-phrase-text{
      color: rgb(6, 21, 14);
    font-family: Roboto, sans-serif;
    font-size: 16px;
    /* border-inline: 1px black solid; */
    border-bottom: 1px lightgray dashed;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    width: 210px;
}

.start-time.tooltip-starttime{
  position:absolute;
  font-size: 13px;
  left:5px;
  top:27px;
  cursor:default!important;
  border-bottom: 1px solid rgba(96, 101, 123, 0.24);
}

.warning-reason{
  font-size: 12px;
  margin-bottom: 5px;
}
.warning-reason i{
    color: rgb(255, 101, 0);
    caret-color: rgb(255, 101, 0);
    padding:5px;
}



.media-frame {
  z-index: 5;
  position:relative;
}

.media-player {
  background: black;
  box-shadow: 0 5px 8px rgba(1, 1, 5, 0.45);
  margin: 0 auto;
  display: block;
  z-index: 5;
  transition: all 0.15s ease;
  cursor: pointer;
  border-radius:5px;
}

.media-container {
  /* margin: 0 10px 0 10px; */
  margin:0px;
  box-shadow: 0 1px 4px rgba(1, 1, 1, 0.15);
  position: fixed;

  /* width: calc(100% - 20px); */
  width: 100%;;
  top: 0px;
  z-index: 1;

  -moz-user-select: none;
  user-select: none;
}
.video-fullscreen {
    position: absolute;
    right: 0px;
}
.video-fullscreen .v-icon{
  font-size: 23px!important;
}

.float-caption {
  width: 334px;
  margin: 0 auto;
  min-height: 23px;
  background: rgba(1, 1, 5,1);
  position: relative;
  z-index: 3;
  /* bottom: 20px; */
  text-align: center;
  color: whitesmoke;
}


.pop-out .float-caption{
      width: 100%;
      margin: 0px 10px 0px 10px;
}

.float-caption-container {
  margin-left: 0px;
  margin-right: 0px;
  width: calc(100% - 305px);
  position: absolute;
  width:100%;
  /* bottom: 52px; */
    bottom: 10px;
}

.media-popout-card.v-card{
  box-shadow: none!important;
  -webkit-box-shadow: none!important;
}

.media-control-button{
  display: flex;
}

.pop-out .float-caption-container {
    margin-left: 0px;
    margin-right: 0px;
    width: 100%;
    position: absolute;
    /* bottom: 20px; */
}

.pop-out .media-display-container{
  border-radius: 10px;
    border-top-left-radius: 10px!important;
    border-top-right-radius: 10px!important;
    padding-top:0px;
    opacity:1;
  /* padding:0px; */
  /* background:rgba(69, 212, 190, 0.4) !important; */
  /* background:#45CF90; */
  /* background:rgba(69, 207, 144, 0.8); */
    background:rgba(255, 255, 255, 0.9);
      -webkit-box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);
    box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);


}

.pop-out .moveable{

  border-radius: 10px;
}


.float-caption-placeholder {
  width: 100%;
  height: 60px;
  opacity: 0;
  position: relative;
  z-index: -1;
  bottom: 110px;
  text-align: center;
  color: whitesmoke;
  font-size: 14px;
  line-height: 30px;
}

.media-display-container {
  background: #ebf4fa;
  padding: 10px 0px;
  min-height: 100px !important;
      display: block;
}

.media-container .pop-out{
      left: 38px;
    top: 97px;
  width:auto!important;
  height:auto!important;
  position:fixed;
  z-index: 10000;
  /* min-width:325px; */
      background: none;
    box-shadow: none;
}


.media-container .hide-pop-out{
 display:none;
}

.fullscreen .media-control-container {
  margin-top: 10px;
}
.media-control-container {
  background: rgba(0, 0, 0, 1);
  height: 30px;
  /* padding: 0px 30px; */
  z-index: 0;
  position: absolute;
  z-index: 5;
  margin-top: -40px!important;

  transform: translateY(15px) scaleY(0);
  width: 334px;
  margin-left: calc(50% - 167px)!important;

  opacity: 0;
  
  transition:0.2s;
}

.media-control-container .custom-slider {
  margin-top:5px;
  padding-left:15px;
  padding-right:15px;
  background: black;
    height: 20px;
}

.media-control-container.control-visible{
  transform: translateY(0px) scaleY(1);
  opacity: 1;
}

.fullscreen.media-slider-container {
  padding-top: 50px;
}

.media-time-end,
.media-time-start {
  width: 80px;
  text-align: center;
  color: #2f3b35;
  font-size: 11px;
  letter-spacing: 2px;
  height: 16px;
  font-weight: bold;
  background: #e4e9fe;
  border-radius: 2px;
  font-family: Roboto, sans-serif;
  border-radius: 10px;
}

.media-time-end.loading,
.media-time-start.loading {
  color:gray;
}

.media-slider-container {
  background: #ebf4fa;
  height: 16px;
  margin: 0px 1px !important;
}

.media-slider-container > .flex{
  background: #ebf4fa;
}

.media-control {
  width: 100%;
  display:flex;
}

.media-control-button {
  caret-color: #0062ff !important;
  color: whitesmoke !important;
  background: transparent;
  background-color: transparent !important;
  border: 0px solid;
  width: 40px !important;
  height: 30px !important;
  min-width: 0px !important;
  box-shadow: none !important;
  -webkit-box-shadow: none !important;
  border-radius: 0px;
  padding: 0px !important;
  margin: 0px;
}

.media-control-button.v-btn::before{
  border-radius: 0px;
  background:#36afb4;
  opacity:0;
    -webkit-transition: all 200ms ease-in;
    transition: all 200ms ease-in;
  /* -webkit-transition: opacity 0.2s cubic-bezier(0.4, 0, 0.6, 1);
    transition: opacity 0.2s cubic-bezier(0.4, 0, 0.6, 1); */

}
.media-control-button.v-btn:hover::before{
  border-radius: 0px;
  background:white!important;
  opacity:0.2!important;
    -webkit-transition: all 200ms ease-in;
    transition: all 200ms ease-in;
  /* -webkit-transition: opacity 0.2s cubic-bezier(0.4, 0, 0.6, 1);
    transition: opacity 0.2s cubic-bezier(0.4, 0, 0.6, 1); */

}

.media-slider-container.hoverable:hover {
  background: transparent !important;
  background-color: transparent !important;
}
.media-slider {
  margin-top: 0px;
  margin: 0 auto;
}

.custom-slider {
  margin-top:5px;
}

.custom-slider .v-slider--horizontal {
    z-index:10;
    margin-right:1px;
    margin-left:1px;
}

.custom-slider .v-slider__track-background.primary.lighten-3 {
      height: 8px;
    top: -3px;
    border-radius: 5px;
  background-color: lightgray !important;
}

.custom-slider .v-slider__track__container,
.custom-slider .v-slider__track,
.custom-slider .v-slider__track-fill {
  height: 8px;
  left: 0px !important;
  top:-3px;
  border-radius:5px;
}

.custom-slider .v-slider__track-fill:before {
  content: "";
  position: absolute;
  right: 10px;
  height: 100%;
  width: 20px;
}

.media-slider-container:hover .v-slider__thumb,
.custom-slider .v-slider__thumb:hover{
  display: block;
  background: black;
  height: 20px;
  width: 20px;
  margin: 0;
  opacity: 0.4;
  /* background: radial-gradient(circle at 6px 6px, #20F7C4, rgb(53, 80, 42))!important;
  transition:none!important; */
}
/* centering the sphere*/

.custom-slider .v-slider__thumb {
  background-color: #36afb4 !important;
  left: -9px;
  width: 12px;
  height: 12px;
  border: 1px #36afb4 solid !important;
  top: 0px;
  border-radius: 50%;
  transition:0.3s;
}
/* 
.custom-slider .v-slider--vertical {
  margin-top: 0px;
  margin-bottom: 1px;
}

.custom-slider .v-slider--vertical .v-slider__thumb {
  height: 10px;
}

 */
 .custom-slider .v-slider__thumb:before {
  width: 0px;
  height: 0px;
}
.media-control-button,
.media-control-container .v-icon {
  font-size: 20px;
}
/* .custom-slider .v-slider--vertical .v-slider__track-container {
  width: 8px;
}

.custom-slider .v-slider--vertical .v-slider__thumb {
  height: 10px;
  width: 40px;
  left: -20px;
  top: -2px;
} */

/* .custom-slider .v-slider__thumb-container{
  z-index: 1;
}
.custom-slider .v-slider--horizontal .v-slider__track-container {
  z-index:2;
} */

.custom-slider .v-input__slot {
  margin-top: -3px;
}

.audio-placeholder {
    height: auto;
    width: 334px;
    margin: 0 auto;
    background: black;
    border-radius: 5px;
    min-height:200px;
}

.media-player:hover {
  opacity: 0.8;
}

.dark .media-player{
  box-shadow: 0 4px 16px 0 rgba(96, 101, 123, 0.24) !important;
    -webkit-box-shadow: 0 4px 16px 0 rgba(96, 101, 123, 0.24) !important;
}

.dark .custom-slider .v-slider__track-background.primary.lighten-3 {
  background-color: gray !important;
}

.dark .media-slider-container{
  background:#1c1e21!important;
}

.dark .media-slider-container > .flex{
  background:#1c1e21!important;
}

.dark .media-time-warning .media-time-inner{
  background:#3A3b3c;
}


.dark .media-time-warning{
  background:orange;
}

@media only screen and (max-device-width: 600px) {
.v-slider--horizontal {
    margin-left: 0px;
    margin-right: 0px;
}

.custom-slider .v-slider__track-background,
  .custom-slider .v-slider__track-fill{
      height: 5px!important;
}

  .media-control-container {
    display: block !important;
    width: 100%;
    margin-top: -40px!important;
    margin-left:0px;
  }
.float-caption-container {
  width:100%;
  margin-left:0px;
  left: 0;
    bottom: 10px;
}
.float-caption {
  width:100%;
}
  .media-display-container {
    min-height: 150px !important;
}

.media-slider-container{
  margin-top: -4px;
  height:0px;

      margin-left: 8px!important;
    margin-right: -2px!important;

}


.media-time-end,
.media-time-start {
  display:none
}
.custom-slider .v-input__slot {
  margin-top: -6px;
}
}
</style>
